import _ from 'lodash'
import router from '../router'
import axios from 'axios'
import qs from 'qs'
import { Message } from 'element-ui'
import store from '../store'

/**
 * Had to use `defaults` to make timeout work.
 * see: https://github.com/axios/axios/issues/1503
 * see: https://github.com/axios/axios/issues/647
 */
axios.defaults.timeout = 10 * 1000
axios.defaults.headers.post = { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }
axios.defaults.headers.put = { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }
axios.defaults.headers.patch = { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }

let sessionTimeOutTimestamp = new Date().getTime()

/** 200 response, but also has follow critical errors. */
const GLOBAL_RS_CODE = { 401: '登录失效',403: '暂无权限', 400: '非法请求', 500: '服务异常，请联系管理员获取支持' }

axios.interceptors.response.use(resp => {
  if (resp.status && resp.status === 200) {
    let rs = resp.data
    let msg = GLOBAL_RS_CODE[rs.code]
    if (msg) {
      Message.error({ message: msg })
      return rs
    }
    return rs
  }
}, err => {
  if (err.message === 'Network Error') {
    Message.error({ message: '网络异常，请重新登录' })
    router.push({ name: 'Login' })
    return
  } else if (err.message.includes('timeout')) {
    Message.error({ message: '请求超时' })
    return
  }

  if (err.response.status === 500 || err.response.status === 504 || err.response.status === 404) {
    Message.error({ message: '未知错误，请联系管理员' })
  } else if (err.response.status === 401) {
    /* avoid multi Message Box alerts */
    let tmpSessionTimeOutTimestamp = new Date().getTime()
    if (tmpSessionTimeOutTimestamp - sessionTimeOutTimestamp > 10 * 1000) {
      sessionTimeOutTimestamp = tmpSessionTimeOutTimestamp
      Message.error({ message: '会话过期，请重新登录' })
    }
    router.push({ name: 'Login' })
  } else {
    Message.error({ message: '未知错误' })
  }
  // return Promise.resolve(err)
})

/**
 * Delegate `axios.get` with hidden the `config.params` option. `params` must be JSON object.
 */
export const xhrGet = (url, params, config) => {
  return axios.get(`${url}`,
    _.isNil(params) ? config : _.merge({}, { params: params }, config)
  )
}

const QS_STRINGIFY_OPTION = { skipNulls: true, indices: false }

/**
 * Delegate `axios.post`. `data` must be JSON object.
 * @param url post url
 * @param data form object
 * @param config axios config
 * @param qsOptions qs.stringfy options
 */
export const xhrPost = (url, data, config, qsOptions) => {
  return axios.post(`${url}`,
    qs.stringify(data, qsOptions || QS_STRINGIFY_OPTION),
    config
  )
}

/**
 * Delegate `axios.put`. `data` must be JSON object.
 */
export const xhrPut = (url, data, config) => {
  return axios.put(`${url}`,
    qs.stringify(data, QS_STRINGIFY_OPTION),
    config
  )
}

/**
 * Delegate `axios.patch`. `data` must be JSON object.
 */
export const xhrPatch = (url, data, config) => {
  return axios.patch(`${url}`,
    qs.stringify(data, QS_STRINGIFY_OPTION),
    config
  )
}

/**
 * Delegate `axios.delete`.
 */
export const xhrDelete = (url, config) => {
  return axios.delete(`${url}`, config)
}

export const xhrFilePost = (url, data, config) => {
  if (!(data instanceof FormData)) {
    console.log('expect FormData', data)
  }
  return axios.post(`${url}`, data, config)
}

export const xhrFilePut = (url, data, config) => {
  if (!(data instanceof FormData)) {
    console.log('expect FormData', data)
  }
  return axios.put(`${url}`, data, config)
}

export const isLoggedUser = () => {
  let user = store.state.user
  let ssoToken = (document.cookie.match('(^|[^;]+)\\s*' + 'sso-token' + '\\s*=\\s*([^;]+)') || []).pop()
  console.log(user,ssoToken)
  // if (user && user.token && user.token === ssoToken) {
  //   return true
  // }
  if (user && user.token && ssoToken) {
    return true
  }
  return false
}



// WEBPACK FOOTER //
// ./src/sso/util/xhr-apis.js